import { render, staticRenderFns } from "./invoice-table.vue?vue&type=template&id=a8c38f52&scoped=true&"
import script from "./invoice-table.ts?vue&type=script&lang=ts&"
export * from "./invoice-table.ts?vue&type=script&lang=ts&"
import style0 from "./invoice-table.scss?vue&type=style&index=0&id=a8c38f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c38f52",
  null
  
)

export default component.exports